import React from 'react';
import {
  CardMedia,
  Card,
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { useImpression } from '@thd-olt-component-react/impression';
import { useQuoteContext } from '../../../hooks/useQuoteContext';
import QuotesHeader from '../QuotesHeader';
import NullViewContent from './NullViewContent';
import { nullStatePropTypes } from './nullStatePropTypes';

const CompactNullView = ({
  imageAlt,
  imageUrl
}) => {
  const { componentId } = useQuoteContext();

  const { ref, clickID } = useImpression({
    data: {
      component: 'QuotesFallbackView',
      name: 'QuotesFallbackView',
      id: componentId,
      position: 1,
      type: 'content',
    }
  });

  return (
    <Card
      data-component="Quotes"
      data-testid="compact-null-view"
      className="sui-h-full"
      CardContentProps={{
        className: classNames(
          'sui-flex-col',
          'sui-flex',
          'sui-gap-2',
          'sui-h-full',
          'sui-p-4',
          'sui-w-full'
        )
      }}
      ref={ref}
      clickid={clickID}
    >
      <div className="sui-pb-1">
        <QuotesHeader hideActionLink />
      </div>
      <div
        className={
          classNames(
            '@7xl:sui-max-w-md',
            'sui-flex-col',
            'sui-flex',
            'sui-gap-4',
            'sui-h-full',
            'sui-overflow-hidden',
          )
        }
      >
        <CardMedia
          src={imageUrl}
          alt={imageAlt}
          aspect="wide"
        />
        <div
          className={
            classNames(
              '@3xl:sui-pr-8',
              '@7xl:sui-max-w-md',
              'sui-flex-col',
              'sui-flex',
              'sui-gap-4',
              'sui-h-full',
              'sui-pt-1'
            )
          }
        >
          <NullViewContent />
        </div>
      </div>
    </Card>
  );
};

CompactNullView.propTypes = nullStatePropTypes;

export default CompactNullView;
